import { getClientConfig } from 'constants/clients';

const normalizedHost = (host = '') => String(host).toLowerCase().replace(/^www\./, '').split(':')[0];

export const getCartStoreKey = () => {
  if (typeof window === 'undefined') return 'server';
  const client = getClientConfig();
  return normalizedHost(client?.host || window.location.hostname) || 'store';
};

export const getScopedCartKey = (baseKey) => `${baseKey}:${encodeURIComponent(getCartStoreKey())}`;

export const getCartStorageKeys = () => ({
  items: getScopedCartKey('lenceria-cart'),
  itemsSub: getScopedCartKey('lenceria-sub-cart'),
  token: getScopedCartKey('lenceria-cart-token'),
});

const createUuid = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = Math.floor(Math.random() * 16);
    return (char === 'x' ? random : ((random & 0x3) | 0x8)).toString(16);
  });
};

export const getCartToken = () => {
  if (typeof localStorage === 'undefined') return null;
  const { token: tokenKey } = getCartStorageKeys();
  let token = localStorage.getItem(tokenKey);
  if (!token) {
    token = createUuid();
    localStorage.setItem(tokenKey, token);
  }
  return token;
};

export const rotateCartToken = () => {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(getCartStorageKeys().token);
  }
};
